import React from "react";
import {
    Box,
    Typography,
    Paper,
    TextField,
    Button,
    Alert,
    Stack,
    CircularProgress
} from "@mui/material";
import { api, baseURL } from "../../services/api";
import { maskCNPJ } from "../../utils/mask";
import { validateBr } from 'js-brasil';

export default function AffiliateCertificate() {
    const [cnpj, setCnpj] = React.useState("");
    const [loading, setLoading] = React.useState(false);
    const [error, setError] = React.useState("");
    const [success, setSuccess] = React.useState("");

    const handleGenerateCertificate = async () => {
        setError("");
        setSuccess("");
        let validCnpj = cnpj;
        
        if (validCnpj.replace(/\D/g, "").length !== 14 || !validateBr.cnpj(cnpj)) {
            setError("Digite um CNPJ válido.");
            return;
        }
        
        setLoading(true);
        try {
            const cnpjClean = cnpj.replace('/', '%2F');
            const { data } = await api.get(`/affiliate-payment/certificate/${cnpjClean}`);
            
            if (data) {
                // Abre uma nova janela e escreve o HTML retornado pela API
                const newWindow = window.open('', '_blank');
                if (newWindow) {
                    newWindow.document.write(data);
                    newWindow.document.close();
                    setSuccess("Certificado gerado com sucesso!");
                } else {
                    setError("Não foi possível abrir o certificado. Verifique se o popup não foi bloqueado.");
                }
            } else {
                setError("Certificado não disponível para este CNPJ.");
            }
        } catch (err) {
            if (err.response?.data?.error?.message) {
                setError(err.response.data.error.message);
            } else {
                setError("Erro ao gerar certificado. Tente novamente.");
            }
        }
        setLoading(false);
    };

    return (
        <React.Fragment>
            <Box sx={{ maxWidth: 900, margin: "auto", padding: 4 }}>
                <Typography variant="h4" align="center" gutterBottom fontWeight={700} color="#004D91">
                    Certificado de Filiação
                </Typography>
                <Paper elevation={3} sx={{ padding: 4, mb: 4 }}>
                    <Stack spacing={3}>
                        <TextField
                            label="CNPJ"
                            value={cnpj}
                            onChange={e => setCnpj(maskCNPJ(e.target.value))}
                            inputProps={{ maxLength: 18 }}
                            fullWidth
                            error={!!error}
                            helperText="Digite o CNPJ da empresa filiada"
                        />
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={handleGenerateCertificate}
                            disabled={loading || cnpj.replace(/\D/g, "").length !== 14 || !validateBr.cnpj(cnpj)}
                        >
                            {loading ? <CircularProgress size={24} /> : "Gerar Certificado"}
                        </Button>
                        {error && <Alert severity="error">{error}</Alert>}
                        {success && <Alert severity="success">{success}</Alert>}
                    </Stack>
                </Paper>
            </Box>
        </React.Fragment>
    );
}
